import { useData } from './useData';
import { createMicrosoftGraphClient, TeamsFx } from '@microsoft/teamsfx';
import { Client } from '@microsoft/microsoft-graph-client';

type Options = {
  scope?: string[];
  loginWhenReload?: boolean;
  auto?: boolean;
};

export const GRAPH_SCOPES = [
  'User.Read',
  'Channel.ReadBasic.All',
  'Team.ReadBasic.All',
];

export function useGraph(asyncFunc: (graph: Client) => any, options?: Options) {
  const { scope, loginWhenReload, auto }: Options = {
    scope: GRAPH_SCOPES,
    ...options,
  };
  const initial = useData(
    async () => {
      try {
        const teamsFx = new TeamsFx();
        const graph = createMicrosoftGraphClient(teamsFx, scope);
        return await asyncFunc(graph);
      } catch (err: any) {
        if (err.code.includes('UiRequiredError')) {
          // Silently fail for user didn't login error
        } else {
          throw err;
        }
      }
    },
    { auto },
  );

  const { data, error, loading, reload } = useData(
    async () => {
      const teamsFx = new TeamsFx();
      if (loginWhenReload) {
        await teamsFx.login(scope);
      }
      const graph = createMicrosoftGraphClient(teamsFx, scope);
      return await asyncFunc(graph);
    },
    { auto: false },
  );

  return data || error || loading
    ? { data, error, loading, reload }
    : {
        data: initial.data,
        error: initial.error,
        loading: initial.loading,
        reload,
      };
}
